import React from 'react'
import { IoClose } from "react-icons/io5";

const ModalSmall = ({ isOpen, onClose, onConfirm, children }) => {
  return (
    <>
      <div
        className={`fixed flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-300 ${isOpen ? "inset-0 opacity-100 z-999999" : "opacity-0"
          }`}
      >
        <div
          className={`bg-white rounded-lg shadow-xl w-96 p-4 transform transition-transform duration-300 ${isOpen ? "scale-100" : "scale-90"
            }`}
        >
          {children}

          <div className="flex justify-end space-x-1">
            <button
              onClick={onConfirm}
              className="rounded-[3px] mr-1 mb-1 border-solid text-[13px] px-4 py-2 uppercase font-black"
              style={{ color: " rgb(51, 51, 51)", background: "rgb(236, 240, 241)" }}
            >
              Confirm
            </button>
            <button
              onClick={onClose}
              className="rounded-[3px] mr-1 mb-1 border-solid text-[13px] px-4 py-2 uppercase font-black"
              style={{ color: " rgb(51, 51, 51)", background: "rgb(236, 240, 241)" }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

const ModalLarge = ({ isOpen, title, onClose, modalWidth = true, children }) => {
  return (
    <>
      <div
        className={`fixed flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-300 ${isOpen ? "inset-0 opacity-100 z-999999" : "opacity-0"
          }`}
      >
        <div
          className={`bg-white rounded-lg shadow-xl ${modalWidth ? "w-full md:max-w-2xl" : "w-full md:max-w-md"} transform transition-transform duration-300 ${isOpen ? "scale-100" : "scale-90"
            }`}
        >
          <div className="bg-[#3c8dbc] text-white text-xl font-semibold p-4 rounded-t-lg flex justify-between items-center">
            <span>{title}</span>
            <button type='button' onClick={onClose}>
              <IoClose />
            </button>
          </div>
          {children}
        </div>
      </div>
    </>
  )
}

export {
  ModalSmall,
  ModalLarge
};
